/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PostureAccountModel {
    getFixupPrototypeFunction() { return PostureAccountModel.fixupPrototype; }

    static newInstance(model: Partial<PostureAccountModel>): PostureAccountModel {
        let obj = Object.assign(new PostureAccountModel(), model);
        PostureAccountModel.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PostureAccountModel>): PostureAccountModel {
        if (!model) return null;
        return PostureAccountModel.newInstance(<PostureAccountModel> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PostureAccountModel) {
        if (!obj) return;

        models.PostureAccountModel.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PostureAccountModel): boolean {
        Object.setPrototypeOf(obj, PostureAccountModel.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.count === undefined) {
            this.count = 0;
        }
        if (this.billable === undefined) {
            this.billable = 0;
        }
        if (this.non_billable === undefined) {
            this.non_billable = 0;
        }
    }

    /**
     * cloud account name
     */
    cloud_account_name: string;

    /**
     * total count details
     */
    count: number;

    /**
     * billable count details
     */
    billable: number;

    /**
     * non_billable count details
     */
    non_billable: number;

}
